<template>
    <div>
        <b-breadcrumb class="breadcrumb-slash">
            <b-breadcrumb-item v-if="!modal" href="#home">
                <feather-icon icon="HomeIcon"></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-for="item in items" :key="item.text" @click="changeRoute(item.link)" :active="item.active">
                {{item.text}}
            </b-breadcrumb-item>
        </b-breadcrumb>
    </div>
</template>

<script>
    import {BBreadcrumb, BBreadcrumbItem} from "bootstrap-vue"

    export default {
        components: {
            BBreadcrumb,
            BBreadcrumbItem,
        },
        props: ["items", "modal"],
        data: () => ({}),
        methods: {
            changeRoute(link) {
                console.log("link", link);
                this.$router.push({name: link});
            }
        }
    }
</script>

<style>
    .breadcrumb {
        padding: 0;
    }
</style>
